import { ChevronLeft } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";

export const ModificationHeader = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const mod = useSelector(ExperienceBuilderSelector.getVariationDraft);
  const hasChanges = useSelector(
    ExperienceBuilderSelector.hasVariationDraftChanges
  );

  const handleClick = async () => {
    const result = await dispatch(
      ExperienceBuilderAction.cancelDraft()
    ).unwrap();
    if (result && mod) {
      void dispatch(
        ExperienceBuilderAction.trackModEditCancelled({
          mod,
          hasUnsavedChanges: hasChanges,
        })
      );
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      onClick={handleClick}
      sx={{
        px: 3,
        height: 64,
        cursor: "pointer",
        borderBottom: `1px solid ${theme.igBorders.core.default}`,
        backgroundColor: "white",
      }}
    >
      <ChevronLeft size={16} />
      <IgTypography variant="body1" fontWeight={600}>
        All modifications
      </IgTypography>
    </Stack>
  );
};
